import axios3C from "../axios";

export const getPaymentMethods = async options => {
  return await axios3C.post("/paymentmethods", {
    action: "getPaymentMethods",
    ...options
  });
};
